import React from 'react';

const QuickMaiaModal = ({ state }) => {
  const {
    selectedAgents,
    setSelectedAgents,
    maiaQuery,
    setMaiaQuery,
    quickMaiaQuery,
    setQuickMaiaQuery,
    setShowQuickMaia,
    researchBriefs,
    setResearchBriefs,
    setActiveDomain,
    setActiveView,
  } = state;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.85)',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      zIndex: 1000,
      overflow: 'auto',
      padding: '60px 20px'
    }}>
      <div style={{
        backgroundColor: '#1e1e32',
        borderRadius: 16,
        width: '100%',
        maxWidth: 800,
        border: '1px solid #2d2d44'
      }}>
        {/* Header */}
        <div style={{
          padding: '20px 24px',
          borderBottom: '1px solid #2d2d44',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 40,
              height: 40,
              borderRadius: 8,
              background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 20
            }}>
              {'\uD83D\uDD2C'}
            </div>
            <div>
              <h2 style={{ margin: 0, fontSize: 18, fontWeight: '600', color: '#f3f4f6' }}>MAIA Deep Research</h2>
              <p style={{ margin: 0, fontSize: 12, color: '#6b7280' }}>Multi-Agent Intelligence Analysis</p>
            </div>
          </div>
          <button
            onClick={() => { setShowQuickMaia(false); setQuickMaiaQuery(''); setMaiaQuery(''); }}
            style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 24, cursor: 'pointer' }}
          >{'\u00D7'}</button>
        </div>

        {/* Search Input */}
        <div style={{ padding: 24 }}>
          <div style={{
            display: 'flex',
            gap: 12,
            marginBottom: 20
          }}>
            <input
              type="text"
              placeholder="What would you like to research?"
              value={maiaQuery || quickMaiaQuery}
              onChange={(e) => setMaiaQuery(e.target.value)}
              style={{
                flex: 1,
                padding: '14px 16px',
                backgroundColor: '#252540',
                border: '1px solid #374151',
                borderRadius: 8,
                color: '#f3f4f6',
                fontSize: 14,
                outline: 'none'
              }}
            />
            <button
              onClick={() => {
                // Simulate research - in real app would call MAIA
                const newBrief = {
                  id: Date.now(),
                  title: maiaQuery?.substring(0, 50) + (maiaQuery?.length > 50 ? '...' : ''),
                  query: maiaQuery || quickMaiaQuery,
                  agents: selectedAgents.map(a => a === 'claude' ? 'Claude' : a === 'grok' ? 'Grok' : a === 'openai' ? 'OpenAI' : a === 'trendhunter' ? 'Trend Hunter GPT' : a),
                  trendContext: null,
                  summary: 'Research in progress... Results will appear here once analysis is complete.',
                  createdAt: new Date().toLocaleString(),
                  status: 'completed'
                };
                setResearchBriefs(prev => [newBrief, ...prev]);
                setShowQuickMaia(false);
                setQuickMaiaQuery('');
                setMaiaQuery('');
                setActiveDomain('research');
                setActiveView('dashboard');
              }}
              style={{
                padding: '14px 24px',
                backgroundColor: '#f59e0b',
                border: 'none',
                borderRadius: 8,
                color: '#0f0f1a',
                fontSize: 14,
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: 8
              }}
            >
              <span>{'\uD83D\uDD0D'}</span> Research
            </button>
          </div>

          {/* Agent Selection */}
          <div style={{ marginBottom: 20 }}>
            <p style={{ margin: '0 0 12px', fontSize: 12, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Select Agents</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {[
                { id: 'claude', name: 'Claude', color: '#8b5cf6' },
                { id: 'grok', name: 'Grok', color: '#ef4444' },
                { id: 'openai', name: 'OpenAI', color: '#10b981' },
                { id: 'trendhunter', name: 'Trend Hunter GPT', color: '#f59e0b' },
                { id: 'mcclatchy_news', name: 'McClatchy News', color: '#3b82f6' },
                { id: 'mcclatchy_le', name: 'McClatchy L&E', color: '#06b6d4' }
              ].map(agent => (
                <button
                  key={agent.id}
                  onClick={() => {
                    setSelectedAgents(prev =>
                      prev.includes(agent.id)
                        ? prev.filter(a => a !== agent.id)
                        : [...prev, agent.id]
                    );
                  }}
                  style={{
                    padding: '8px 14px',
                    backgroundColor: selectedAgents.includes(agent.id) ? `${agent.color}20` : '#252540',
                    border: `1px solid ${selectedAgents.includes(agent.id) ? agent.color : '#374151'}`,
                    borderRadius: 6,
                    color: selectedAgents.includes(agent.id) ? agent.color : '#9ca3af',
                    fontSize: 12,
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                >
                  {agent.name}
                </button>
              ))}
            </div>
          </div>

          {/* Recent Research */}
          <div>
            <p style={{ margin: '0 0 12px', fontSize: 12, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Recent Research</p>
            <div style={{ display: 'grid', gap: 8 }}>
              {researchBriefs.slice(0, 3).map(brief => (
                <div
                  key={brief.id}
                  onClick={() => {
                    setActiveDomain('research');
                    setShowQuickMaia(false);
                  }}
                  style={{
                    padding: 12,
                    backgroundColor: '#252540',
                    borderRadius: 8,
                    border: '1px solid #374151',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.borderColor = '#f59e0b'}
                  onMouseOut={(e) => e.currentTarget.style.borderColor = '#374151'}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ fontSize: 14 }}>{'\uD83D\uDD2C'}</span>
                      <span style={{ fontSize: 13, color: '#f3f4f6', fontWeight: '500' }}>{brief.title}</span>
                    </div>
                    <span style={{ fontSize: 11, color: '#6b7280' }}>{brief.createdAt}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickMaiaModal;
